var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasModal)?_c('div',{staticClass:"modal-container"},[_c(_vm.modal.component,{tag:"component",attrs:{"options":_vm.modal.options},on:{"resolve":_vm.resolve,"close":_vm.close}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }